import { createContext, useState, useEffect, useContext } from "react";
import {
  getAuthUser,
  setAuthUser,
  setAuthToken,
  clearAuthSession,
} from "../utils/storage";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // On app load/tab open, check if user is logged in for THIS tab
    const checkAuth = () => {
      const u = getAuthUser();
      if (u) {
        setUser(u);
      }
      setLoading(false);
    };

    checkAuth();

    const handleUserUpdate = () => {
      const u = getAuthUser();
      setUser(u);
    };

    window.addEventListener("user-updated", handleUserUpdate);
    return () => window.removeEventListener("user-updated", handleUserUpdate);
  }, []);

  const login = (userData, token) => {
    setAuthUser(userData);
    if (token) setAuthToken(token);
    setUser(userData);
    window.dispatchEvent(new Event("user-updated"));
  };

  const logout = () => {
    clearAuthSession();
    setUser(null);
    window.dispatchEvent(new Event("user-updated"));
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
